<div class="mainmenu">
  <a class="logo" [routerLink]="['/']" title="{{ 'MENU.MAIN_STORE' | translate }}">
    <img src="assets/icons/icon-transparent.png" />
  </a>

  <mat-divider></mat-divider>

  @if (appStatus(); as appStatus) {
    @if (!appStatus.authStatus) {
      <mat-nav-list>
        <a mat-list-item [routerLink]="['/login']" routerLinkActive="active">
          <div matListItemTitle translate="LOGIN.TITLE"></div>
        </a>
        <a mat-list-item [routerLink]="['/signup']" routerLinkActive="active">
          <div matListItemTitle translate="LOGIN.LINK.REGISTER"></div>
        </a>
      </mat-nav-list>
    }
    @if (appStatus.authStatus) {
      <mat-nav-list>
        <!-- the basics: apiary, hives, logs -->
        <a mat-list-item [routerLink]="['/apiary']" routerLinkActive="active">
          <div translate="SIDEBAR.APIARIES"></div>
        </a>
        <a mat-list-item [routerLink]="['/hive']" routerLinkActive="active">
          <div translate="SIDEBAR.HIVES"></div>
        </a>
        <a mat-list-item [routerLink]="['/logs']" routerLinkActive="active">
          <div translate="SIDEBAR.LOGS"></div>
        </a>
        <!-- honey house submenu -->
        <a mat-list-item [routerLink]="['/harvest']" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }" class="menu-parent">
          <div matListItemTitle translate="MENU.MAIN_HARVEST"></div>
        </a>
        <mat-nav-list class="sub" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }">
          <!-- collect harvest is currently not active -->
          <!--
          <a mat-list-item [routerLink]="['/harvest/collect']" routerLinkActive="active">
            <div matListItemLine translate="MENU.HARVEST"></div>
          </a>
          -->
          <a mat-list-item [routerLink]="['/harvest/harvests']" routerLinkActive="active">
            <div matListItemLine translate="MENU.HARVESTS"></div>
          </a>
          <a mat-list-item [routerLink]="['/harvest/lots']" routerLinkActive="active">
            <div matListItemLine translate="MENU.LOTS"></div>
          </a>
        </mat-nav-list>
        <!-- notes -->
        <a mat-list-item [routerLink]="['/notes']" routerLinkActive="active">
          <div translate="SIDEBAR.NOTES"></div>
        </a>
        <!-- statistics -->
        <a mat-list-item [routerLink]="['/stats']" routerLinkActive="active">
          <div translate="SIDEBAR.STATISTICS"></div>
        </a>
        @if (appStatus.features.admin) {
          <a mat-list-item [routerLink]="['/documents']" routerLinkActive="active">
            <div translate="MENU.DOCUMENTS"></div>
          </a>
        }
        @if (appStatus.features.inventory) {
          <a mat-list-item [routerLink]="['/inventory']" routerLinkActive="active">
            <div translate="MENU.MAIN_INVENTORY"></div>
          </a>
        }
        @if (appStatus.features.inventory) {
          <mat-nav-list class="sub" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }">
            <a mat-list-item [routerLink]="['/inventory/overview']" routerLinkActive="active">
              <div matListItemLine translate="MENU.INVENTORY"></div>
            </a>
            <a mat-list-item [routerLink]="['/inventory/inventory']" routerLinkActive="active">
              <div matListItemLine translate="MENU.PURCHASES"></div>
            </a>
            <a mat-list-item [routerLink]="['/inventory/applications']" routerLinkActive="active">
              <div matListItemLine translate="MENU.ITEM_USES"></div>
            </a>
            @if (appStatus.features.documents) {
              <a mat-list-item [routerLink]="['/documents']" routerLinkActive="active">
                <div matListItemLine translate="MENU.DOCUMENTS"></div>
              </a>
            }
          </mat-nav-list>
        }
        @if (appStatus.features.admin) {
          <a mat-list-item [routerLink]="['/admin/translations']" routerLinkActive="active">
            <div>Admin: Translation</div>
          </a>
        }
        <a mat-list-item [routerLink]="['/account']" routerLinkActive="active">
          <div matListItemTitle>
            <span  translate="ACCOUNT.ACCOUNT_INFORMATION"></span> /
            <span  translate="MENU.SETTINGS"></span>
          </div>
        </a>
      </mat-nav-list>
    }
  }
</div>
